import { render, staticRenderFns } from "./PostprocessingTemplatesPage.vue?vue&type=template&id=63116df6&scoped=true&"
import script from "./PostprocessingTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./PostprocessingTemplatesPage.vue?vue&type=script&lang=js&"
import style0 from "./PostprocessingTemplatesPage.vue?vue&type=style&index=0&id=63116df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63116df6",
  null
  
)

export default component.exports